const BaseSuppressionsCollection = require("./base_suppressions_collection");
const APIConfig = require("apiconfig");

module.exports = BaseSuppressionsCollection.extend({
  url() {
    return this.decorateUrl(`${APIConfig.host}suppression/${this.type}`);
  },
});
